@if (attachForm) {
  <div [formGroup]="attachForm">
    <div class="flex flex-column gap-1">
      <div class="flex flex-row align-items-center" [style]="{'width': '31rem'}">
        <label for="bestandOldId" class="w-10rem justify-content-start">
          {{ isStorno ? ("investment.label.holdings.plain" | translate) : ("investment.label.holdings.old" | translate) }}
        </label>
        <p-input-group class="w-21rem">
          <input class="text-right" appAmountInput formControlName="bestandOld" id="bestandOldId" pInputText />
          <p-inputGroupAddon class="bg-transparent ">EUR</p-inputGroupAddon>
        </p-input-group>
      </div>
      @if (!isStorno) {
        <div class="flex flex-row align-items-center" [style]="{'width': '31rem'}">
          <label for="form_bestand_neu" class="w-10rem justify-content-start">
            {{ "investment.label.holdings.new" | translate }}
          </label>
          <p-input-group class="w-21rem">
            <input class="text-right" appAmountInput formControlName="bestandNew" id="form_bestand_neu" pInputText />
            <p-inputGroupAddon class="bg-transparent">EUR</p-inputGroupAddon>
          </p-input-group>
        </div>
      }
    </div>
  </div>
}
